var Notifications = {
    conn: null,
    init: function () {

        var protocol = window.location.protocol === 'https:' ? 'wss' : 'ws';
        this.conn = new WebSocket(protocol+"://"+window.location.host+"/apc/notifications/ws/");
        this.conn.onopen = function() {
            console.log("Connected!");
        };
        this.conn.onmessage = function (e) {
            var json = JSON.parse(e.data);
            if(json.type === "basic")
                console.log(json);
            else if (json.type === "update")
                location.reload();
            else
                Notifications.createPushNotifications(json);
        };
        this.conn.onclose = function() {
            console.error("Connection broken.");
        };
    },
    createPushNotifications: function (json) {
        if (json.length > 0) {
            $('.notification-badge').addClass("bg-danger").removeClass("bg-secondary").text(json.length);
            Push.create("astri.ee",
                {
                    body: json[0].message,
                    link: "/apc/notifications/",
                    icon: "/assets/favicon.ico",
                    onClick: function() { window.open(json[0].url) }
                });
        }
    },
    sendReadRequest: function (id){
        Notifications.conn.send("setRead:"+id);
    },
    sendReadAllRequest: function (){
        Notifications.conn.send("readAll");
    },
    requestNotifications: function () {
        if (typeof Admin == "object") {
            Push.Permission.request(
                function success() {
                },
                function failure() {
                }
            )
        }
    }
};